import { BlogStoreType } from "store/type";

export const initGlobalState: BlogStoreType = {
  saveBlogLoading: false,
	updateBlogLoading: false,
  deleteBlogLoading: false,
  blogs: {
    loading: false,
    data: [],
    total: 0,
    page: 1,
    limit: 10,
  },
};
